// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e2VL","type":"styles_type__1jPVB","choices":"styles_choices__WT_qU"};